module.exports = __webpack_public_path__ + "static/media/upstate.bc6d341d.svg";